export const isIE = window.navigator.userAgent.indexOf("MSIE") > -1 ||  window.navigator.userAgent.indexOf("Trident/") > -1;

export const b2cPolicies = {
  tokenRenewalOffsetSeconds: 600,
  authorities: {
    signIn: {
      authority: "https://luminavlinkdev.b2clogin.com/tfp/luminavlinkdev.onmicrosoft.com/B2C_1_SI",
    },
  },
  redirectUri: window.location.origin,
  authorityDomain: "xxxx", //Luminav Pro Dev - Client App
  clientId: "xxxx", //Luminav Pro Dev - Client App
};
export const API_ACCESS_SCOPE = "https://luminavlinkdev.onmicrosoft.com/webapi/read";

export const silentRequest = {
  scopes: ['openid', 'profile']
}


